<div class="thread" [class.review-thread]="variant === 'review'" dir="rtl">
  <div class="comment-row">
    <div class="avatar">{{ initials(comment.username) }}</div>
    <div class="content">
      <div class="heading"><strong>{{ comment.username }}</strong><span>{{ comment.timeAgo }}</span></div>
      @if (variant === 'review' && comment.starRating) {
        <div class="review-stars" [attr.aria-label]="comment.starRating + ' מתוך 5 כוכבים'">
          @for (star of [1, 2, 3, 4, 5]; track star) {
            <span [class.active]="star <= comment.starRating">★</span>
          }
        </div>
      }
      <p>@if (comment.replyToUsername) { <b>{{ comment.replyToUsername }}</b> } {{ comment.text }}</p>
      <div class="tools">
        @if (comment.id) {
          <span class="reaction-control" (pointerdown)="$event.stopPropagation()">
            <button class="reaction-main" [class.selected]="comment.userReaction" title="לחיצה ארוכה לבחירת תגובה" (pointerdown)="startReactionPress($event)" (pointerup)="finishReactionPress($event)" (pointercancel)="cancelReactionPress()" (pointerleave)="cancelReactionPress()">{{ reactionEmoji(comment.userReaction) }}@if (totalReactions()) { <small>{{ totalReactions() }}</small> }</button>
            @if (reactionMenuOpen) {
              <span class="reaction-menu" (pointerdown)="$event.stopPropagation()">
                @for (item of [{key:'like',icon:'👍',label:'אהבתי'},{key:'rocket',icon:'🚀',label:'רוקט'},{key:'fire',icon:'🔥',label:'אש'},{key:'ice',icon:'❄️',label:'קרח'},{key:'giggles',icon:'😆',label:'מצחיק'}]; track item.key) {
                  <button [title]="item.label" [class.selected]="comment.userReaction === item.key" (pointerdown)="chooseReaction($event, item.key)">{{ item.icon }}</button>
                }
              </span>
            }
          </span>
          <button class="reply" (click)="replyRequested.emit(comment)">השב</button>
        }
        @if (comment.starRating && variant !== 'review') { <span class="comment-rating">{{ comment.starRating }} ★</span> }
      </div>
    </div>
  </div>
  @if (isReplying) {
    <div class="composer"><input [ngModel]="replyText" (ngModelChange)="replyTextChange.emit($event)" [placeholder]="'תשובה ל־' + comment.username" (keydown.escape)="replyCancelled.emit()" /><button aria-label="שליחה" [disabled]="replySubmitting" (click)="replySubmitted.emit()"><mat-icon>send</mat-icon></button><button aria-label="סגירה" class="cancel" (click)="replyCancelled.emit()"><mat-icon>close</mat-icon></button></div>
  }
  @if (children.length) {
    <button class="view-replies" (click)="expanded = !expanded"><mat-icon>{{ expanded ? 'expand_less' : 'expand_more' }}</mat-icon>{{ expanded ? 'הסתר תשובות' : 'הצג ' + children.length + ' תשובות' }}</button>
    @if (expanded) {
      <div class="children">
        @for (child of children; track child.id || $index) {
          <app-trend-comment-thread [comments]="comments" [comment]="child" [postId]="postId" [replyTarget]="replyTarget" [replyText]="replyText" [replySubmitting]="replySubmitting" [variant]="variant" (replyRequested)="replyRequested.emit($event)" (replyTextChange)="replyTextChange.emit($event)" (replySubmitted)="replySubmitted.emit()" (replyCancelled)="replyCancelled.emit()" (reactionRequested)="reactionRequested.emit($event)"></app-trend-comment-thread>
        }
      </div>
    }
  }
</div>
